import { render, staticRenderFns } from "./ConfirmEmailPage.vue?vue&type=template&id=6fafeda2&"
import script from "./ConfirmEmailPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmailPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmailPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports